import { gql } from "@apollo/client";

export const GET_HOME_DATA_ADMIN = gql`
  query getHomeDataAdmin(
    $sinceDate: timestamptz!
    $excludeTestOrgNamePattern: String!
  ) {
    epaRequirements: requirement(limit: 3, where: { type: { _eq: "EPA" } }) {
      requirement_id
      name
      type
      description
    }
    competencyRequirements: requirement(
      limit: 3
      where: { type: { _eq: "COMPETENCY" } }
    ) {
      requirement_id
      name
      type
      description
    }

    feedbacks: feedback(
      limit: 5
      order_by: { observation_date: desc }
      where: {
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
        created_at: { _gte: $sinceDate }
        organization: { name: { _nilike: $excludeTestOrgNamePattern } }
      }
    ) {
      course
      animal_sex
      site {
        site_id
        name
      }
      species {
        species_id
        name
      }
      observation_date
      feedback_id
      student_id
      student {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      coach_id
      coach {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      feedback_skills {
        feedback_skill_id
        requirement {
          name
          requirement_id
          type
        }
        self_rating
        coach_rating
      }
      status
    }
    feedbackStatsData: feedback(
      where: {
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
        created_at: { _gte: $sinceDate }
        organization: { name: { _nilike: $excludeTestOrgNamePattern } }
      }
    ) {
      status
      observation_date
      created_at
      reviewed_at
      feedback_id
      coach_id
      coach {
        user_id
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
        email
        name
      }
      student_id
      student {
        user_id
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
        email
        name
      }
    }
  }
`;

export const GET_HOME_DATA_COACH = gql`
  query getHomeDataCoach(
    $userId: uuid!
    $sinceDate: timestamptz!
    $excludeTestOrgNamePattern: String!
  ) {
    epaRequirements: requirement(limit: 3, where: { type: { _eq: "EPA" } }) {
      requirement_id
      name
      type
      description
    }
    competencyRequirements: requirement(
      limit: 3
      where: { type: { _eq: "COMPETENCY" } }
    ) {
      requirement_id
      name
      type
      description
    }
    pendingFeedbacks: feedback(
      limit: 20
      order_by: { created_at: desc }
      where: { coach_id: { _eq: $userId }, status: { _eq: "PENDING" } }
    ) {
      feedback_id
      status
      created_at
      observation_date
      student {
        user_id
        name
      }
      coach {
        user_id
        name
      }
    }
    feedbacks: feedback(
      limit: 20
      order_by: { created_at: desc }
      where: {
        coach_id: { _eq: $userId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
      }
    ) {
      feedback_id
      student_id
      course
      animal_sex
      site {
        site_id
        name
      }
      species {
        species_id
        name
      }
      observation_date
      created_at
      student {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      feedback_skills {
        feedback_skill_id
        requirement {
          name
          requirement_id
          type
        }
        self_rating
        coach_rating
      }
      status
    }

    feedbackStatsData: feedback(
      where: {
        coach_id: { _eq: $userId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
        created_at: { _gte: $sinceDate }
        organization: { name: { _nilike: $excludeTestOrgNamePattern } }
      }
    ) {
      feedback_id
      status
      observation_date
      created_at
      reviewed_at
      coach_id
      student {
        user_id
        name
      }
      coach {
        user_id
        name
      }
    }
  }
`;

export const GET_HOME_DATA_STUDENT = gql`
  query getHomeDataStudent(
    $userId: uuid!
    $sinceDate: timestamptz!
    $excludeTestOrgNamePattern: String!
  ) {
    feedbacksApproved: feedback(
      limit: 5000
      order_by: { observation_date: desc }
      where: {
        student_id: { _eq: $userId }
        status: { _eq: "DONE" }
        created_at: { _gte: $sinceDate }
        organization: { name: { _nilike: $excludeTestOrgNamePattern } }
      }
    ) {
      feedback_id
      coach_rate
      feedback_skills {
        requirement_id
        feedback_skill_id
        skill_level
        self_rating
        coach_rating
      }
    }

    pendingFeedbacks: feedback(
      limit: 20
      order_by: { created_at: desc }
      where: { student_id: { _eq: $userId }, status: { _eq: "PENDING" } }
    ) {
      feedback_id
      status
      created_at
      observation_date
      coach {
        user_id
        name
      }
      student {
        user_id
        name
      }
    }
    feedbacks: feedback(
      limit: 20
      order_by: { created_at: desc }
      where: {
        student_id: { _eq: $userId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
      }
    ) {
      feedback_id
      org_id
      student_id
      coach_id
      species_id
      animal_size
      mrn
      status
      note_to_coach
      created_at
      reviewed_at
      observation_date
      animal_sex
      organization {
        org_id
        name
      }
      student {
        user_id
        email
        name
      }
      coach {
        user_id
        email
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      species {
        name
        species_id
      }
      feedback_skills {
        actions
        areas
        coach_comments
        feedback_skill_id
        note
        requirement {
          name
          requirement_id
          type
          description
          overview
        }
        self_rating
        coach_rating
        student_comments
      }
    }
    resources: graduation_class(
      where: { students: { student: { user_id: { _eq: $userId } } } }
    ) {
      current_academic_year {
        requirements {
          requirement {
            resources {
              resource {
                description
                name
                resource_id
                url
              }
            }
          }
        }
      }
    }
    graduation_class(
      where: { students: { student: { user_id: { _eq: $userId } } } }
    ) {
      current_academic_year {
        requirements {
          requirement_id
          requirement {
            requirement_id
            name
            description
            task_time
            animal_size
            type
            overview
            requirement_type
            min_performance
            min_score
            min_small_animals_count
            min_large_animals_count
            competencies {
              competency {
                requirement_id
                name
                description
                task_time
                animal_size
                type
                overview
                requirement_type
                min_performance
                min_score
                min_small_animals_count
                min_large_animals_count
              }
            }
            resources {
              resource {
                description
                name
                resource_id
                url
              }
            }
          }
        }
      }
    }
    feedbackStatsData: feedback(
      limit: 5000
      where: {
        student_id: { _eq: $userId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
        created_at: { _gte: $sinceDate }
        organization: { name: { _nilike: $excludeTestOrgNamePattern } }
      }
      order_by: { observation_date: asc }
    ) {
      status
      observation_date
      created_at
      reviewed_at
      coach_id
      feedback_skills {
        requirement_id
        self_rating
        coach_rating
      }

      feedback_id
      coach {
        user_id
        picture_url
        email
        name
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      student_id
      student {
        user_id
        picture_url
        email
        name
      }
    }
    mentors: mentoring(where: { mentee_id: { _eq: $userId } }) {
      mentor {
        user_id
        picture_url
        email
        name
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
    }
  }
`;

export const GET_HOME_DATA_MANAGER = gql`
  query getHomeDataManager(
    $orgId: uuid!
    $sinceDate: timestamptz!
    $excludeTestOrgNamePattern: String!
  ) {
    feedbacks: feedback(
      limit: 5
      order_by: { observation_date: desc }
      where: {
        org_id: { _eq: $orgId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
        created_at: { _gte: $sinceDate }
        organization: { name: { _nilike: $excludeTestOrgNamePattern } }
      }
    ) {
      feedback_id
      student_id
      student {
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
        user_id
        email
        name
      }
      coach_id
      coach {
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
        user_id
        email
        name
      }
      feedback_skills {
        feedback_skill_id
        requirement {
          name
          requirement_id
          type
        }
        coach_rating
        self_rating
      }
      status
    }

    feedbackStatsData: feedback(
      where: {
        org_id: { _eq: $orgId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
        created_at: { _gte: $sinceDate }
        organization: { name: { _nilike: $excludeTestOrgNamePattern } }
      }
    ) {
      status
      observation_date
      created_at
      reviewed_at
      feedback_id
      coach_id
      coach {
        user_id
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
        email
        name
      }
      student_id
      student {
        user_id
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
        email
        name
      }
    }
  }
`;

/**
 * Lightweight Home lists. Matches the feedback-list query: the caller's own
 * rows only, no test-org inner join and no period window. The full home
 * query is too large for some prod tenants and can leave these widgets
 * stale while the list page still works.
 */
export const GET_HOME_LEARNER_ACTIVITY = gql`
  query getHomeLearnerActivity($userId: uuid!) {
    pendingFeedbacks: feedback(
      limit: 20
      order_by: { created_at: desc }
      where: { student_id: { _eq: $userId }, status: { _eq: "PENDING" } }
    ) {
      feedback_id
      status
      created_at
      observation_date
      feedback_type
      course
      animal_sex
      site {
        site_id
        name
      }
      species {
        species_id
        name
      }
      coach {
        user_id
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      student {
        user_id
        name
      }
      feedback_skills {
        feedback_skill_id
        requirement {
          name
          requirement_id
          type
        }
        self_rating
        coach_rating
      }
    }
    feedbacks: feedback(
      limit: 20
      order_by: { created_at: desc }
      where: {
        student_id: { _eq: $userId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
      }
    ) {
      feedback_id
      status
      created_at
      observation_date
      feedback_type
      course
      animal_sex
      site {
        site_id
        name
      }
      species {
        species_id
        name
      }
      coach {
        user_id
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      student {
        user_id
        name
        picture_url
      }
      feedback_skills {
        feedback_skill_id
        requirement {
          name
          requirement_id
          type
        }
        self_rating
        coach_rating
      }
    }
  }
`;

export const GET_HOME_COACH_ACTIVITY = gql`
  query getHomeCoachActivity($userId: uuid!) {
    pendingFeedbacks: feedback(
      limit: 20
      order_by: { created_at: desc }
      where: { coach_id: { _eq: $userId }, status: { _eq: "PENDING" } }
    ) {
      feedback_id
      status
      created_at
      observation_date
      student {
        user_id
        name
      }
      coach {
        user_id
        name
      }
    }
    feedbacks: feedback(
      limit: 20
      order_by: { created_at: desc }
      where: {
        coach_id: { _eq: $userId }
        status: { _nin: ["DRAFT", "ARCHIVED", "HIDDEN"] }
      }
    ) {
      feedback_id
      status
      created_at
      observation_date
      feedback_type
      course
      animal_sex
      site {
        site_id
        name
      }
      species {
        species_id
        name
      }
      student {
        user_id
        name
        picture_url
        equipped_store_items(where: { item_type: { _eq: "PET" } }) {
          item_type
          store_item {
            store_item_id
            name
            slug
            type
            rarity
            asset_key
          }
        }
      }
      coach {
        user_id
        name
      }
      feedback_skills {
        feedback_skill_id
        requirement {
          name
          requirement_id
          type
        }
        self_rating
        coach_rating
      }
    }
  }
`;
